import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import MainNavigation from '../../components/ui/MainNavigation';
import CustomersTab from './components/CustomersTab';

const ResellerDashboard = () => {
  const { user, userProfile, loading } = useAuth();
  const [activeTab, setActiveTab] = useState('customers');

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Laden...</p>
        </div>
      </div>
    );
  }

  if (!user || !['reseller', 'superadmin']?.includes(userProfile?.user_type)) {
    return <Navigate to="/provider-login" replace />;
  }

  const tabs = [
    { id: 'customers', label: 'Klanten', icon: 'Users' },
    { id: 'partnerships', label: 'Partnerschappen', icon: 'Handshake' },
    { id: 'revenue', label: 'Omzet', icon: 'DollarSign' },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'customers':
        return <CustomersTab />;
      case 'partnerships':
        return (
          <div className="bg-card border border-border rounded-lg p-12 text-center">
            <Icon name="Handshake" size={48} className="text-muted-foreground mx-auto mb-4" />
            <p className="text-muted-foreground">Partnerschappen beheer komt binnenkort beschikbaar</p>
          </div>
        );
      case 'revenue':
        return (
          <div className="bg-card border border-border rounded-lg p-12 text-center">
            <Icon name="DollarSign" size={48} className="text-muted-foreground mx-auto mb-4" />
            <p className="text-muted-foreground">Omzet dashboard komt binnenkort beschikbaar</p>
          </div>
        );
      default:
        return <CustomersTab />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <MainNavigation />

      <main className="pt-16 lg:pt-0 lg:ml-[72px] transition-all duration-300">
        {/* Header */}
        <div className="bg-card border-b border-border">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-3xl font-heading font-bold text-foreground flex items-center space-x-3">
                  <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center">
                    <Icon name="Building" size={24} color="white" />
                  </div>
                  <span>Reseller Dashboard</span>
                </h1>
                <p className="text-muted-foreground mt-2">
                  Beheer uw klanten en partnerschappen
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs Navigation */}
        <div className="bg-card border-b border-border">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex space-x-1 overflow-x-auto">
              {tabs?.map((tab) => (
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center space-x-2 px-6 py-4 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                    activeTab === tab?.id
                      ? 'border-primary text-primary bg-primary/5' :'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
                  }`}
                >
                  <Icon name={tab?.icon} size={18} />
                  <span>{tab?.label}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Tab Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {renderTabContent()}
        </div>
      </main>
    </div>
  );
};

export default ResellerDashboard;